export default "__VITE_ASSET__o5KuG7Yz__"